import Api from '../../api/index';
import router from '@/router';

const Check = {
  namespaced: true,
  state: {
    tk: null,
    valid: false,
  },
  getters: {
    
  },

  mutations: {
    validateSessionToken(state, tk){
      state.tk = tk 
    },
    validateSessionPermission(state, permission){
      state.valid = permission
    },
  },

  actions: {
    validateSession(context, tk){
      context.commit('validateSessionPermission', false)
      Api.ClientOrder.validate(tk).then(r=>{
        sessionStorage.setItem('order_token', tk)
        context.commit('validateSessionToken', tk)
        context.commit('validateSessionPermission', r.data)
      }).catch(err=> {
        console.log(err)
        sessionStorage.removeItem('order_token')
        context.commit('validateSessionPermission', false)
        router.push({name: 'UnauthorizedClientOrderDetails'});
        throw Error(err)
      })
    },
  }

};

export default Check;
